var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"match-height"},[_c('b-col',{attrs:{"xl":"2","md":"4","sm":"6"}},[_c('statistic-card-vertical',{attrs:{"icon":"LayersIcon","statistic":"1","statistic-title":"Companies","color":"info"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }